export default {
  upload: '/mrx-gateway/mrxassistmemberservice/admin/api/upload',
  download: '/mrx-gateway/mrxassistmemberservice/admin/api/download',
  refreshClient: '/mrx-gateway/api/client_clear_all',
  refreshFeature: '/mrx-gateway/api/feature_clear_all',
  disconnectDatabase: '/mrx-gateway/api/client_db_close_all'
}
